<ng-container *ngIf="data$ | async as data">
  <cx-generic-link
    *ngIf="hasUrl(data); else showImage"
    [url]="data.urlLink"
    [target]="getTarget(data)"
  >
    <p class="headline" *ngIf="data.headline" [innerHTML]="data.headline"></p>
    <eb-responsive-media [container]="data.media"></eb-responsive-media>
    <p class="content" *ngIf="data.content" [innerHTML]="data.content"></p>
  </cx-generic-link>

  <ng-template #showImage>
    <eb-responsive-media [container]="data.media"></eb-responsive-media>
  </ng-template>
</ng-container>
